import z from 'zod';

export interface UpdateUserNeedRequestDto {
  title?: string;
  categoryId?: number;
  subcategoryId?: number;
  status?: string;
  note?: string;
}

export const CreateUserNeedRequestSchema = z.object({
  userId: z.string(),
  title: z.string(),
  categoryId: z.number().optional(),
  subcategoryId: z.number().optional(),
  status: z.string(),
  note: z.string().optional(),
});

export const UpsertUserNeedRequestSchema = CreateUserNeedRequestSchema.extend({
  userNeedId: z.number().optional(),
});

export type UpsertUserNeedRequest = z.infer<typeof UpsertUserNeedRequestSchema>;

export interface AddNeedResourceDetailsToActionRequest {
  id?: number;
  resourceName: string;
  contactName?: string;
  phoneNumber?: string;
  url?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  shouldDelete?: boolean;
  /** Canonical CBO row when saved via upsert before the action is created. */
  cboRecordId?: string;
}

export interface NeedAddActionRequest {
  activityId: number;
  originalActionId?: number;
  date: string;
  durationInMinutes: number;
  description: string;
  markAsFulfilled: boolean;
  resourceReferrals?: AddNeedResourceDetailsToActionRequest[];
  suggestedActionId?: string;
}

export interface NeedPatchRequest {
  reason?: string;
  issueId?: number;
  shouldExtend?: boolean;
  abandoned?: boolean;
  fulfilled?: boolean;
  comment?: string;
}

export interface NeedCreationRequest {
  memberId: string;
  issueId: number;
  reason: string;
  tempNeedId?: string;
}

export interface TransferNeedRequest {
  needId: number;
  targetMemberId: string;
}

export interface ConsolidateDuplicateNeedsRequest {
  memberId: string;
  date?: string;
}
